<template>
  <div class="free-vid-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入用户ID" clearable v-model="params.uid" size="small" @change="getfreeVidList()" class="param-input"></el-input>
      <el-button type="primary" size="small" @click="getfreeVidList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="addfreeVid('add')">+新增免费观看配置</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" @sort-change="handleSortChange">
      <el-table-column prop="uid" label="用户ID" align="center" min-width="240" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.uid || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="publisherID" label="发布者ID" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.publisherID.join(",")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.startTime | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.endTime | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button type="success" class="el-icon-edit" size="mini" @click="addfreeVid('edit',scope.row)"></el-button>
          <el-button type="danger" class="el-icon-delete" size="mini" @click="remove(scope.row.uid.toString())"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30, 50, 100]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑弹框-->
    <add-free ref="addFree" @handlerList="getfreeVidList"></add-free>
  </div>
</template>

<script>
import AddFree from "./components/addFree"
import API from '@/api'
import { sortEscape } from '@/utils/global'
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        uid:''
      },
      uids:[]
    }
  },
  components: {
    AddFree
  },
  created() {
    this.getfreeVidList();
  },
  methods: {
    // 请求列表
    getfreeVidList(type) {
      this.loading = true;
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getfreeVidList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除
    remove(uid) {
      this.$confirm('您确定要删除当前信息吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
         uids:Array(uid).map(v=>+v)
        }
        API.deletefreeVid(param).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getfreeVidList('status')
          } else {
            this.$message.error('删除失败')
          }
        })
      })
    },
    // 新增、编辑操作
    addfreeVid(type, data) {
      this.$refs.addFree.open(type, data)
    },
        // 数据排序
    handleSortChange(column) {
      this.params.value = sortEscape(column.order)
      this.params.key = column.prop;
      this.getfreeVidList()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.pageNumber = 1
      this.getfreeVidList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getfreeVidList()
    },
  }
}
</script>
